module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-19.f7007330.svg";